import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  signInAnonymously,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAbo-WXjKbNNfkEviZp3kYfmeGnr-CNLdc",
  authDomain: "ttptechllc-5b637.firebaseapp.com",
  projectId: "ttptechllc-5b637",
  storageBucket: "tttptechllc-5b637.firebasestorage.app",
  messagingSenderId: "642907208039",
  appId: "1:642907208039:web:a6ad37441254a2d4c157c2",
  measurementId: "G-3VVQZF36MV",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// 1️⃣ Initialize Auth & ensure we always return a Promise in our .then
const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    if (!auth.currentUser) {
      // return the signIn promise...
      return signInAnonymously(auth);
    }
    // …otherwise return a resolved Promise so ESLint happy about consistent-return
    return Promise.resolve();
  })
  .then(() => console.log("✅ Anonymous auth ready"))
  .catch((err) => console.error("Auth init error:", err));

const db = getFirestore(app);
const storage = getStorage(app);

getAnalytics(app);

export { app, auth, db, storage, collection, addDoc };
